import React, { useState } from 'react'
import StaticPage from '../components/StaticPage'
import { ManifestGallery } from '../components/Gallery'
import './GalleryPage.css'

/**
 * Photo gallery index. The legacy site had per-site photo galleries (Joomla
 * SIGE {gallery}folder{/gallery} shortcodes); our media CDN holds the same
 * folders and ManifestGallery renders them. Here we list the site galleries
 * and let the visitor open one at a time.
 */
const GALLERIES = [
  { folder: 'bodesbeck', name: 'Bodesbeck Law' },
  { folder: 'cacrabank', name: 'Cacra Bank' },
  { folder: 'fastheugh', name: 'Fastheugh' },
  { folder: 'witchieknowe', name: 'Witchie Knowe' },
  { folder: 'mountbenger', name: 'Mountbenger' },
  { folder: 'bridgend', name: 'Bridgend' },
  { folder: 'jubileecairn', name: 'Jubilee Cairn' },
  { folder: 'foulshiels', name: 'Foulshiels' },
  { folder: 'craighill', name: 'Craig Hill' },
  { folder: 'ettrickpen', name: 'Ettrick Pen' },
  { folder: 'talla', name: 'Talla' },
  { folder: 'minto_hills', name: 'Minto Hills' },
  { folder: 'Borders_Open_97', name: 'Borders Open 97' },
]

function GalleryPage() {
  const [open, setOpen] = useState(null)

  return (
    <StaticPage title="Gallery" intro="Photos from around the Wingbeat sites">
      <p className="muted">Choose a gallery to view its photos.</p>
      <div className="gallery-index">
        {GALLERIES.map((g) => (
          <button
            key={g.folder}
            className={`gallery-index-item ${open === g.folder ? 'active' : ''}`}
            onClick={() => setOpen(open === g.folder ? null : g.folder)}
          >
            {g.name}
          </button>
        ))}
      </div>

      {open && (
        <div className="gallery-viewer">
          <h2>{GALLERIES.find((g) => g.folder === open)?.name}</h2>
          <ManifestGallery folder={open} columns={4} />
        </div>
      )}
    </StaticPage>
  )
}

export default GalleryPage
